import index from './pages/index'

const routes = [
    {
        path: '/contact',
        name: 'Contact',
        component: index
    }
]

export default routes



// WEBPACK FOOTER //
// ./src/app/contact/routes.js